import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { toggleLanguage } from '../../redux/slices/languageSlice';
import ContactModal from '../ContactModal/ContactModal';
import './FloatingContactIcons.css';

const FloatingContactIcons = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { currentLanguage } = useSelector((state) => state.language);

  const whatsappNumber = '+218911234567';
  const whatsappMessage = currentLanguage === 'en' 
    ? 'Hello, I would like to inquire about Sanad Insurance services.'
    : 'مرحبًا، أود الاستفسار عن خدمات سند للتأمين.';

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const handleLanguageToggle = () => {
    dispatch(toggleLanguage());
  };

  return (
    <>
      <div className="floating-contact-icons">
        {/* زر تغيير اللغة */}
        <motion.button
          className="floating-icon language-icon"
          onClick={handleLanguageToggle}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          whileHover={{ scale: 1.1, y: -5 }}
          whileTap={{ scale: 0.95 }}
          title={currentLanguage === 'en' ? 'Change Language' : 'تغيير اللغة'}
        >
          <span className="icon">
            {currentLanguage === 'en' ? 'عربى' : 'EN'}
          </span>
          <span className="tooltip">
            {currentLanguage === 'en' ? 'Change to Arabic' : 'التغيير إلى الإنجليزية'}
          </span>
        </motion.button>

        {/* أيقونة الواتساب */}
        <motion.a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-icon whatsapp-icon"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          whileHover={{ scale: 1.1, y: -5 }}
          whileTap={{ scale: 0.95 }}
          title={currentLanguage === 'en' ? 'Chat on WhatsApp' : 'محادثة على واتساب'}
        >
          <span className="icon">💬</span>
          <span className="tooltip">
            {currentLanguage === 'en' ? 'Chat on WhatsApp' : 'محادثة على واتساب'}
          </span>
        </motion.a>

        {/* أيقونة الاتصال */}
        <motion.button
          className="floating-icon contact-icon"
          onClick={() => setIsContactModalOpen(true)}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.1, y: -5 }}
          whileTap={{ scale: 0.95 }}
          title={currentLanguage === 'en' ? 'Contact Us' : 'تواصل معنا'}
        >
          <span className="icon">📧</span>
          <span className="tooltip">
            {currentLanguage === 'en' ? 'Contact Us' : 'تواصل معنا'}
          </span>
        </motion.button>
      </div>

      {/* مودال الاتصال */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </>
  );
};

export default FloatingContactIcons;

// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { useSelector } from 'react-redux';
// import ContactModal from '../ContactModal/ContactModal';
// import './FloatingContactIcons.css';

// const FloatingContactIcons = () => {
//   const [isContactModalOpen, setIsContactModalOpen] = useState(false);
//   const { currentLanguage } = useSelector((state) => state.language);

//   const whatsappNumber = '+218930825018'; // استبدل برقم واتساب الشركة
//   const whatsappMessage = currentLanguage === 'en' 
//     ? 'Hello, I would like to inquire about Sanad Insurance services.'
//     : 'مرحبًا، أود الاستفسار عن خدمات سند للتأمين.';

//   const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

//   return (
//     <>
//       <div className="floating-contact-icons">
//         {/* أيقونة الواتساب */}
//         <motion.a
//           href={whatsappLink}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="floating-icon whatsapp-icon"
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.5, delay: 0.2 }}
//           whileHover={{ scale: 1.1, y: -5 }}
//           whileTap={{ scale: 0.95 }}
//           title={currentLanguage === 'en' ? 'Chat on WhatsApp' : 'محادثة على واتساب'}
//         >
//           <span className="icon">💬</span>
//           <span className="tooltip">
//             {currentLanguage === 'en' ? 'Chat on WhatsApp' : 'محادثة على واتساب'}
//           </span>
//         </motion.a>

//         {/* أيقونة الاتصال */}
//         <motion.button
//           className="floating-icon contact-icon"
//           onClick={() => setIsContactModalOpen(true)}
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.5 }}
//           whileHover={{ scale: 1.1, y: -5 }}
//           whileTap={{ scale: 0.95 }}
//           title={currentLanguage === 'en' ? 'Contact Us' : 'تواصل معنا'}
//         >
//           <span className="icon">📧</span>
//           <span className="tooltip">
//             {currentLanguage === 'en' ? 'Contact Us' : 'تواصل معنا'}
//           </span>
//         </motion.button>
//       </div>

//       {/* مودال الاتصال */}
//       <ContactModal 
//         isOpen={isContactModalOpen} 
//         onClose={() => setIsContactModalOpen(false)} 
//       />
//     </>
//   );
// };

// export default FloatingContactIcons;